import {KTIcon} from '../../../../_metronic/helpers'

export const ReportRefreshButton = ({
  hovered,
  onMouseEnter,
  onMouseLeave,
  onClick,
}: {
  hovered: boolean
  onMouseEnter: () => void
  onMouseLeave: () => void
  onClick: () => void
}) => {
  return (
    <button
      type='button'
      className='btn btn-icon btn-sm btn-light-primary ms-3'
      style={{
        width: '36px',
        height: '36px',
        transition: 'all 0.2s ease',
        backgroundColor: hovered ? 'var(--bs-primary)' : 'var(--bs-primary-light)',
        color: hovered ? 'var(--bs-primary-inverse)' : 'var(--bs-primary)',
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
    >
      <KTIcon
        iconName='arrows-circle'
        className={`fs-3 px-0 ${hovered ? 'text-white' : 'text-primary'}`}
      />
    </button>
  )
}

export const ReportDownloadButton = ({
  label,
  disabled,
  onClick,
}: {
  label: string
  disabled: boolean
  onClick: () => void
}) => {
  return (
    <button
      disabled={disabled}
      type='button'
      onClick={onClick}
      className='btn btn-primary d-inline-flex align-items-stretch p-0'
      style={{
        minHeight: '41px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      }}
    >
      <span className='px-5 d-flex align-items-center fw-semibold'>{label}</span>
      <span
        style={{
          color: 'var(--bs-primary-inverse)',
          backgroundColor: 'rgba(0, 0, 0, 0.12)',
          padding: '0 15px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          borderTopRightRadius: 'inherit',
          borderBottomRightRadius: 'inherit',
        }}
      >
        <KTIcon iconName='arrow-down' className='fs-2 text-white' />
      </span>
    </button>
  )
}
